<script>
  export default {
    name: 'WelcomeImage'
  }
</script>

<template>
  <div>
    <img src="" alt=""/>
  </div>
</template>

<style scoped>

</style>